import React from 'react';
import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';

export const ConversationItemSkeleton = (): JSX.Element => {
  return (
    <Box
      css={{
        padding: 'default',
        borderBottom: '1px solid',
        borderBottomColor: 'border.subtle',
      }}
    >
      {/* Participant name and date */}
      <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
        <Bone type="line" css={{ width: '60%' }} />
        <Bone type="line" css={{ width: '20%' }} />
      </Box>

      {/* Message preview */}
      <Bone type="line" css={{ width: '70%', marginBlock: 'loose' }} />

      {/* Footer */}
      <Bone type="line" css={{ width: '50%' }} />
    </Box>
  );
};

export const ConversationListSkeleton = () => {
  return (
    <Box css={{ overflowY: 'auto' }}>
      {[...Array(10)].map((_, idx) => {
        return <ConversationItemSkeleton key={idx} />;
      })}
    </Box>
  );
};
